(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // const junip_app_block = document.getElementById("shopify-block-AdTF2Tmo1SXpCOVZ6Z__junip_junip_product_summary_ECKnM8");
  // if (junip_app_block) {
  //   junip_inside_content = junip_app_block.querySelector(".junip-product-summary");
  //   if (junip_inside_content) {
  //     const ratingCount = parseInt(
  //       junip_inside_content.getAttribute("data-product-rating-count"),
  //       10
  //     );

  //     if (ratingCount === 0) {
  //       junip_app_block.style.display = "none";
  //     }
  //   }
  // }
  setTimeout(() => {
    const productTitleLink = document.querySelector(
        '.product-information__grid .product-details .group-block-content a[ref="productTitleLink"]'
    );
    if (!productTitleLink) return;
    // Get next app block
    const junipAppBlock = productTitleLink.nextElementSibling;
    if (!junipAppBlock) return;
    // Optional: get dynamic ID
    const dynamicId = junipAppBlock.id;
    console.log(dynamicId);
    const junipInsideContent = junipAppBlock.querySelector('.junip-product-summary');
    if (!junipInsideContent) return;
    const ratingCount = parseInt(
      junipInsideContent.getAttribute('data-product-rating-count'),
      10
    );
    if (ratingCount === 0) {
      junipAppBlock.style.display = 'none';
    }
  }, 300);

  } catch(e) { console.error(e); }
})();
})();
